import {
    SLQ_USER_LOAD,
    SLQ_USER_UNLOAD,
    SLQ_USER_WALLET_HISTORY_LOAD,
    SLQ_USER_WALLET_LOAD,
    SLQ_USER_WALLET_UNLOAD,
    SLQ_USER_WALLET_HISTORY_UNLOAD,
    SLQ_USER_STATUSES,
    SLQ_USER_AVRS
} from "../../constants/actionTypes";
import {connect} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import agent from "../../agent";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Toast} from "primereact/toast";
import {Fieldset} from "primereact/fieldset";
import {useParams} from "react-router";

const mapStateToProps = state => ({
    ...state.slqUser,
    ...state.avrs,
    ...state.statuses
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: SLQ_USER_LOAD, payload });
    },
    onWalletLoad: (payload) => {
        dispatch({ type: SLQ_USER_WALLET_LOAD, payload });
    },
    onWalletHistoryLoad: (payload) => {
        dispatch({ type: SLQ_USER_WALLET_HISTORY_LOAD, payload });
    },
    onUnload: () => {
        dispatch({ type: SLQ_USER_UNLOAD });
        dispatch({ type: SLQ_USER_WALLET_UNLOAD });
        dispatch({ type: SLQ_USER_WALLET_HISTORY_UNLOAD });
    },
    onStatuses: (payload) => {
        dispatch({ type: SLQ_USER_STATUSES, payload });
    },
    onAvrsLoad: (payload) => {
        dispatch({ type: SLQ_USER_AVRS, payload });
    }
});

const SLQUser = props => {
    const currentPath = window.location.pathname;
    const userId = currentPath.split('/').reverse()[0]
    const initialFilters = {
        userId,
        status: '',
        avrNum: ''
    };
    const initialAvrStatus = {
        avrId: null,
        statusId: null
    };
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [showChangeStatusDialog, setShowChangeStatusDialog] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [editForm, setEditForm] = useState({ lastName: '', firstName: '', email: '', bin: '', companyName: '', legalAddress: '' });
    const [editErrors, setEditErrors] = useState({});
    const [editLoading, setEditLoading] = useState(false);
    const [loadingActivationUl, setLoadingActivationUl] = useState(false);
    const [percent, setPercent] = useState(null);
    const [limit, setLimit] = useState(null);
    const [filters, setFilters] = useState(initialFilters);
    const [discountType, setDiscountType] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [dueDateType, setDueDateType] = useState('');
    const [frequencyAvrType, setFrequencyAvrType] = useState('');
    const [selectedAvrStatus, setSelectedAvrStatus] = useState(initialAvrStatus);
    const createTaskForm = useRef(null);
    const toast = useRef(null);
    const { guid } = useParams();

    const onPageChange = (event) => {
        setPage(event.page)
        setPageSize(event.rows)
        setFirst(event.first)

        if (props.slqUser?.realmId === 'slq_jur') {
            props.onAvrsLoad(agent.SlqUser.getAvrs(filters, event.rows, event.page));
        } else {
            props.onWalletHistoryLoad(agent.SlqUser.getWalletHistory(guid, event.page, event.rows));
        }
    }

    const showMessage = (severity, summary, detail) => {
        toast.current.show({severity: severity, summary: summary, detail: detail, sticky: true });
    }

    const showActivationDialog = () => {
        const response =  agent.Tariff.getTariff(guid)
        response.then(res => {
            if(res) {
                setLimit(res?.limit);
                setDiscountType(res?.discountType);
                setPercent(res?.percent);
                setDueDateType(res?.attribute?.daysToPay || null);
                setFrequencyAvrType(res?.attribute?.fType || null);
                setPaymentType('AFTER');
            }
        })
        setShowCreateDialog(true)
    }

    useEffect(() => {
        props.onAvrsLoad(agent.SlqUser.getAvrs(filters, pageSize, page));
        props.onStatuses(agent.SlqUser.getStatuses());
        props.onLoad(agent.SlqUser.get(guid));
        props.onWalletLoad(agent.SlqUser.getWallet(guid));
        props.onWalletHistoryLoad(agent.SlqUser.getWalletHistory(guid, page, pageSize));
        return function cleanup() {
            props.onUnload()
        };
    }, []);

    const label = {
        "locale": "Локаль",
        "companyName": "Наименование компании",
        "bin": "БИН",
        "location": "Местонахождение",
        "legalAddress": "Адрес"
    }
    const Attributes = props => {
        const isVisible = (str) => {
            return str && str !== "";
        }

        return (
            <div>
            {
                 Object.keys((props.attributes||{})).map((key, id) => {
                     return (
                         <div className="tableRow" key={id} style={{visibility: isVisible(props.attributes[key]) ? 'visible' : 'hidden'}}>
                             <label htmlFor={key} className="infoCardLabel">{label[key]}</label>
                             <div className="infoCardValue">
                                 <input id={key} readOnly defaultValue={props.attributes[key]}/>
                             </div>
                         </div>
                     )
                 })
             }
            </div>
        )}
    const amountBodyTemplate = (rowData) => {
        return (
            <div>
                <span> {(rowData.type === 'DEBIT' ? '-' : '+').concat(rowData.amount)} </span>
            </div>
        );
    }

    const discountTypeSelectItems = [
        {label: 'Надбавка на себестоимость ГП', value: 'DISCOUNT'},
        {label: 'Скидка на стандарт SLQ.kz', value: 'STANDARD'},
        {label: 'Индивидуальный', value: 'INDIVIDUAL'}
    ];

    const paymentTypeSelectItems = [
        {label: 'Предоплата', value: 'BEFORE'},
        {label: 'Постоплата', value: 'AFTER'}
    ];

    const dueDateTypeSelectItems = [
        {label: '4 дня', value: 3},
        {label: '7 дней', value: 6}
    ];

    const frequencyAvrTypeSelectItems = [
        {label: '1 раз в неделю', value: 'EVERY_MONDAY'},
        {label: '1 раз в месяц', value: 'FIRST_MONDAY_OF_MONTH'}
    ];
    
    const onCreateHide = () => {
        setShowCreateDialog(false);
    }
    const renderCreateFooter = () => {
        return (
            <div>
                <Button label="Нет" icon="pi pi-times" onClick={() => onCreateHide()} className="p-button-text" />
                <Button loading={loadingActivationUl} form="createForm" type="submit" label="Да" icon="pi pi-check" autoFocus />
            </div>
        );
    }

    const renderFooter = () => {
        const handleSave = async () => {
            try {
                const result = await agent.SlqUser.setStatus(selectedAvrStatus.avrId);
                if (result.id) {
                    props.onAvrsLoad(agent.SlqUser.getAvrs(initialFilters, 10, 0));
                    setFilters(initialFilters); setPageSize(10); setPage(0);
                    showMessage('success', 'Запрос выполнен', `Статус изменен`);
                    setShowChangeStatusDialog(false);
                }
            } catch(err) {
                if (err.status === 400) {
                    showMessage('error', 'Ошибка', `Данный статус уже присвоен`);
                } else {
                    showMessage('error', 'Ошибка', `Статус не изменен`);
                }
            }
        };

        return (
            <div>
                <Button
                    label="Отменить"
                    icon="pi pi-times"
                    onClick={() => setShowChangeStatusDialog(false)}
                    className="p-button-text"
                />
                <Button
                    label="Сохранить"
                    icon="pi pi-check"
                    form="createForm"
                    onClick={handleSave}
                    autoFocus
                />
            </div>
        );
    };

    const sendCreateForm = (event) => {
        event.preventDefault();
        const data = {
            percent,
            discountType,
            paymentType,
            userId: guid,
            limit: limit,
            attribute: {
                daysToPay: dueDateType,
                fType: frequencyAvrType,
            }
        };
        setLoadingActivationUl(true)
        agent.Tariff.save(data).then((response) =>  {
            onCreateHide();
            showMessage('success', 'Запрос выполнен', `Пользователь активирован `);
        }).catch((err) => {
            showMessage('error', 'Ошибка', `пользователь не активирован ${err}`);
        }).finally(() => {
            setLoadingActivationUl(false)
        });
    }

    const openEditDialog = () => {
        setEditForm({
            lastName: props.slqUser?.lastName || '',
            firstName: props.slqUser?.firstName || '',
            email: props.slqUser?.email || '',
            bin: props.slqUser?.attributes?.bin || '',
            companyName: props.slqUser?.attributes?.companyName || '',
            legalAddress: props.slqUser?.attributes?.legalAddress || '',
        });
        setEditErrors({});
        setShowEditDialog(true);
    };

    const handleEditSave = () => {
        const errors = {};
        if (!editForm.lastName.trim()) errors.lastName = true;
        if (!editForm.firstName.trim()) errors.firstName = true;
        if (!editForm.email.trim()) errors.email = true;
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editForm.email)) errors.emailFormat = true;
        if (!editForm.companyName.trim()) errors.companyName = true;
        if (!editForm.legalAddress.trim()) errors.legalAddress = true;

        if (Object.keys(errors).length > 0) {
            setEditErrors(errors);
            return;
        }

        setEditLoading(true);
        const body = {
            lastName: editForm.lastName,
            firstName: editForm.firstName,
            email: editForm.email,
            companyName: editForm.companyName,
            legalAddress: editForm.legalAddress,
            realmId: props.slqUser?.realmId,
        };
        agent.SlqUser.updateRequisites(guid, body)
            .then(() => {
                props.onLoad(agent.SlqUser.get(guid));
                setShowEditDialog(false);
                showMessage('success', 'Успешно', 'Данные пользователя обновлены');
            })
            .catch(() => showMessage('error', 'Ошибка', 'Не удалось сохранить изменения'))
            .finally(() => setEditLoading(false));
    };

    const handleSearchAvrs = (e) => {
        e.preventDefault(); 
        props.onAvrsLoad(agent.SlqUser.getAvrs(filters, 10, 0));
        setPageSize(10); setPage(0);
    }

    const Table = () => {
        const [expandedRows, setExpandedRows] = useState([]);
        const [row, setRow] = useState(null);
        

        const handleModifyStatus = (val) => {
            setSelectedAvrStatus({
                avrId: val.id,
                statusId: val.status+1
            })
            setShowChangeStatusDialog(true);
        };

        const getStatusValue = (val) => {
            return (
                <div className="p-d-flex p-jc-between">
                    <span className="p-mr-2">{(props?.statuses?.find((stat) => stat?.id === val?.status) || {name: ''}).name}</span>
                    {val.status === 3 ? null : 
                        <Button 
                            onClick={() => handleModifyStatus(val)} 
                            className="p-button-text p-button-rounded" 
                            icon="pi pi-pencil" 
                        />
                    }
                </div>
            )
        };

        const rowExpansionTemplate = (data) => {
            return (
                <div className="orders-subtable">
                    <h4>Позиции в АВР</h4>
                    <DataTable resizableColumns  columnResizeMode="fit" value={data.lines}>
                        <Column field="name" header="Наименование услуги" style={{width:'20%'}} />
                        <Column field="count" header="Количесто" style={{width:'10%'}} />
                        <Column field="weight" header="Вес" style={{width:'10%'}} />
                        <Column field="totalWN" header="Сумма без НДС" style={{width:'10%'}} />
                        <Column field="nds" header="НДС" style={{width:'10%'}} />
                        <Column field="total" header="Сумма" style={{width:'10%'}} />
                        <Column field="info" header="Примечание" />
                    </DataTable>
                </div>
            );
        }

        return (
            <div className="card">
                <DataTable  value={props.avrs?.content} expandedRows={expandedRows} 
                            onRowToggle={(e) => setExpandedRows(e.data)}
                            selection={row} onSelectionChange={e => setRow(e.value)}
                            rowExpansionTemplate={rowExpansionTemplate} dataKey="id">
                    <Column expander style={{ width: '3em' }} />
                    <Column field="avrNum" header="№АВР" />
                    <Column field="startDate" header="Начальная дата" />
                    <Column field="endDate" header="Конечная дата" />
                    <Column field="totalAmount" header="Сумма" />
                    <Column field="status" body={getStatusValue} header="Статус" />
                </DataTable>
                <Paginator
                    currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
                    template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    first={first} rows={pageSize} totalRecords={(props.avrs||{totalElements: 0}).totalElements} rowsPerPageOptions={[1, 10, 25, 50]}
                    onPageChange={onPageChange}
                />
            </div>
        );
    };

    return (
        <div className="p-fluid p-grid p-p-lg-4">
            <Toast ref={toast}/>
            {(props.slqUser || {}).realmId === 'slq_jur' &&
                <Button className="p-mb-3" onClick={() => showActivationDialog()} label="Активация ЮЛ"/>
            }

            <Dialog header="Тарифный план пользователя" visible={showCreateDialog} style={{ width: '50vw' }} footer={renderCreateFooter()}
                    onHide={() => onCreateHide()}>
                <form ref={createTaskForm} id="createForm" onSubmit={(e) => sendCreateForm(e)}>
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-6 p-md-12">
                                <label htmlFor="firstname6" className="p-pb-2">Процент</label>
                                <InputNumber name="percent" value={percent} onValueChange={(e) => setPercent(e.value)}
                                             suffix={" %"} max={100}/>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-6 p-md-12">
                                <label htmlFor="limit" className="p-pb-2">Лимит</label>
                                <InputNumber name="limit" value={limit} onValueChange={(e) => setLimit(e.value)}
                                             suffix={" тенге"} id="limit"/>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-6 p-md-12">
                                <label htmlFor="firstname6" className="p-pb-2">Тип скидки</label>
                                 <Dropdown name="discountType" optionLabel="label" optionValue="value" value={discountType} options={discountTypeSelectItems}
                                           onChange={(e) => setDiscountType(e.value)}/>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-6 p-md-12">
                                <label htmlFor="firstname6" className="p-pb-2">Тип оплаты</label>
                                <Dropdown name="paymentType" optionLabel="label" optionValue="value" value={paymentType} options={paymentTypeSelectItems}
                                          onChange={(e) => setPaymentType(e.value)}/>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-6 p-md-12">
                                <label htmlFor="firstname6" className="p-pb-2">Срок оплаты АВР</label>
                                <Dropdown name="dueDateType" optionLabel="label" optionValue="value" value={dueDateType} options={dueDateTypeSelectItems}
                                          onChange={(e) => setDueDateType(e.value)}/>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-6 p-md-12">
                                <label htmlFor="firstname6" className="p-pb-2">Периодичность выставления АВР</label>
                                <Dropdown name="frequencyAvrType" optionLabel="label" optionValue="value" value={frequencyAvrType} options={frequencyAvrTypeSelectItems}
                                          onChange={(e) => setFrequencyAvrType(e.value)}/>
                            </div>
                        </div>
                    </div>
                </form>
            </Dialog>

            <Dialog
                header="Назначить следующий  статус АВР"
                visible={showChangeStatusDialog}
                style={{ width: '50vw' }}
                footer={renderFooter}
                onHide={() => setShowChangeStatusDialog(false)}
            >
                <p>Статус: {(props.statuses?.find((stat) => stat?.id === selectedAvrStatus?.statusId) || {name: ''})?.name}</p>
            </Dialog>

            <Dialog
                header="Редактирование полей"
                visible={showEditDialog}
                style={{ width: '50vw' }}
                footer={
                    <div>
                        <Button label="Отмена" className="p-button-outlined" icon="pi pi-times" onClick={() => setShowEditDialog(false)} />
                        <Button label="Сохранить" icon="pi pi-check" loading={editLoading} onClick={handleEditSave} autoFocus />
                    </div>
                }
                onHide={() => setShowEditDialog(false)}
            >
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '8px', width: '45%' }}>Поле</th>
                            <th style={{ textAlign: 'left', padding: '8px' }}>Значение</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            { label: 'Логин(Номер телефона)', value: props.slqUser?.username },
                            { label: 'GUID', value: props.slqUser?.id },
                        ].map(({ label, value }) => (
                            <tr key={label}>
                                <td style={{ padding: '6px 8px' }}>{label}</td>
                                <td style={{ padding: '6px 8px' }}>
                                    <InputText value={value || ''} readOnly disabled style={{ width: '100%', background: '#f4f4f4' }} />
                                </td>
                            </tr>
                        ))}
                        {[
                            { label: 'Фамилия', key: 'lastName', error: editErrors.lastName },
                            { label: 'Имя', key: 'firstName', error: editErrors.firstName },
                            { label: 'Email', key: 'email', error: editErrors.email || editErrors.emailFormat, hint: editErrors.emailFormat ? 'Некорректный email' : null },
                            { label: 'ИИН/БИН', key: 'bin', readOnly: true },
                            { label: 'Наименование компании', key: 'companyName', error: editErrors.companyName },
                            { label: 'Адрес', key: 'legalAddress', error: editErrors.legalAddress },
                        ].map(({ label, key, error, hint, readOnly }) => (
                            <tr key={key}>
                                <td style={{ padding: '6px 8px' }}>{label} {!readOnly && <span style={{ color: 'red' }}>*</span>}</td>
                                <td style={{ padding: '6px 8px' }}>
                                    <InputText
                                        value={editForm[key]}
                                        onChange={readOnly ? undefined : (e) => { setEditForm({ ...editForm, [key]: e.target.value }); setEditErrors({ ...editErrors, [key]: false }); }}
                                        readOnly={readOnly}
                                        disabled={readOnly}
                                        style={{ width: '100%', background: readOnly ? '#f4f4f4' : undefined, borderColor: error ? 'red' : undefined }}
                                    />
                                    {hint && <small style={{ color: 'red' }}>{hint}</small>}
                                </td>
                            </tr>
                        ))}
                        {[
                            { label: 'Баланс, ₸', value: props.wallet?.balance },
                            { label: 'В блокировке, ₸', value: props.wallet?.reserved },
                            { label: 'Доступно, ₸', value: props.wallet?.available },
                        ].map(({ label, value }) => (
                            <tr key={label}>
                                <td style={{ padding: '6px 8px' }}>{label}</td>
                                <td style={{ padding: '6px 8px' }}>
                                    <InputText value={value ?? ''} readOnly disabled style={{ width: '100%', background: '#f4f4f4' }} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Dialog>

            <div className="leftSide">
                <h1 className="infoCardTitle">Данные пользователя</h1>
                <div className="infoCard">
                    <div className="tableRow">
                        <label htmlFor="username" className="infoCardLabel">Логин(Номер телефона)</label>
                        <div className="infoCardValue">
                            <input id="username" readOnly defaultValue={(props.slqUser||{}).username}/>
                        </div>
                    </div>
                    <div className="tableRow">
                        <label htmlFor="id" className="infoCardLabel">GUID</label>
                        <div className="infoCardValue">
                            <input id="id" readOnly defaultValue={(props.slqUser||{}).id}/>
                        </div>
                    </div>
                    <div className="tableRow">
                        <label htmlFor="lastName" className="infoCardLabel">Фамилия</label>
                        <div className="infoCardValue">
                            <input id="lastName" readOnly defaultValue={(props.slqUser||{}).lastName}/>
                        </div>
                    </div>
                    <div className="tableRow">
                        <label htmlFor="firstName" className="infoCardLabel">Имя</label>
                        <div className="infoCardValue">
                            <input id="firstName" readOnly defaultValue={(props.slqUser||{}).firstName}/>
                        </div>
                    </div>
                    <div className="tableRow">
                        <label htmlFor="email" className="infoCardLabel">Email</label>
                        <div className="infoCardValue">
                            <input id="email" readOnly defaultValue={(props.slqUser||{}).email}/>
                        </div>
                    </div>
                    <Attributes attributes={(props.slqUser||{}).attributes}/>
                </div>
            </div>
            <div className="rightSide">
                <h1 className="infoCardTitle">Данные кошелька</h1>
                <div className="infoCard">
                    <div className="tableRow">
                        <label htmlFor="username" className="infoCardLabel">Баланс, ₸</label>
                        <div className="infoCardValue">
                            <input id="username" readOnly defaultValue={(props.wallet||{}).balance}/>
                        </div>
                    </div>
                    <div className="tableRow">
                        <label htmlFor="username" className="infoCardLabel">В блокировке, ₸</label>
                        <div className="infoCardValue">
                            <input id="username" readOnly defaultValue={(props.wallet||{}).reserved}/>
                        </div>
                    </div>
                    <div className="tableRow">
                        <label htmlFor="username" className="infoCardLabel">Доступно, ₸</label>
                        <div className="infoCardValue">
                            <input id="username" readOnly defaultValue={(props.wallet||{}).available}/>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px', width: '100%' }}>
                    <Button style={{width: '240px'}} label="Редактировать" icon="pi pi-pencil" onClick={openEditDialog} className="p-button-outlined" />
                </div>
            </div>


            {props.slqUser?.realmId === 'slq_jur' ?
                <div style={{width: '100%'}}>
                    <Fieldset>
                        <form onSubmit={handleSearchAvrs}>
                            <div className="p-fluid p-formgrid p-grid">
                                <div className="p-field p-col-6 p-md-3 hiddenInput">
                                    <label htmlFor="avrNum">Номер АВР</label>
                                    <InputText
                                        id="avrNum" value={filters.avrNum}
                                        onChange={(e) => setFilters({...filters, avrNum: e.target.value})}
                                    />
                                </div>

                                <div className="p-field p-col-6 p-md-3">
                                    <label htmlFor="avrsStatus">Статус АВР</label>
                                    <Dropdown inputId="avrsStatus" value={filters.status ? filters.status : null}
                                        options={props.statuses}
                                        onChange={(e) => setFilters({...filters, status: e.value})}
                                        optionLabel="name"
                                        optionValue="id"
                                        showClear
                                    />
                                </div>
                            </div>

                            <br/>
                            <div className="p-grid p-justify-end">
                                <div className="p-mr-2">
                                    <Button type="submit" label="Найти" autoFocus/>
                                </div>
                                <div className="p-mr-2">
                                    <Button className="p-button-warning" label="Сбросить" onClick={() => setFilters(initialFilters)}/>
                                </div>
                            </div>
                        </form>
                    </Fieldset>
                </div> : null
            }

            {props.slqUser?.realmId === 'slq_jur' && props.avrs?.content ? <Table /> : null}

            {props.slqUser?.realmId === 'slq_jur' ? null :
                <div className="card">
                    <DataTable value={(props.walletHistory||{data: []}).data}
                        className="p-datatable-customers" dataKey="id" rowHover
                        emptyMessage="Данные не найдены" scrollable>
                        <Column headerStyle={{ width: '200px' }} columnKey="info" field="info" header="Событие" sortable/>
                        <Column headerStyle={{ width: '200px' }} columnKey="createdDate" field="createdDate" header="Дата" sortable/>
                        <Column headerStyle={{ width: '200px' }} columnKey="amount" field="amount" header="Сумма, ₸" body={amountBodyTemplate} sortable/>
                    </DataTable>
                    <Paginator currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
                            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            first={first} rows={pageSize} totalRecords={(props.walletHistory||{totalItems: 0}).totalItems} rowsPerPageOptions={[1, 10, 25, 50, 'все']}
                            onPageChange={onPageChange}/>
                </div>
            }
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(SLQUser);
